export default __webpack_public_path__ + "static/media/01.6de0ea13.jpg";